import React from "react";
	 
const FC_MENU_DOMAIN_SUFFIX = 'aft.amazonoperations.app'
//const FC_MENU_DOMAIN_SUFFIX = 'amazon.com'
const hostname = window.location.hostname
	
export const isFcMenuDomain = () => {
	return hostname.endsWith(FC_MENU_DOMAIN_SUFFIX)
}

export const IS_FC_MENU_REQUEST: boolean = isFcMenuDomain()

export function HideForFcMenuUsers({children}: { children: React.ReactNode }) {
	if (IS_FC_MENU_REQUEST) {
		return <></>; // Return empty fragment to not render anything in the DOM
	}
	return <>{children}</>;
}
